
import { defineComponent } from 'vue';
import { HIDE_BORDER } from '@/types/enums';
import DriveUiWrapper from './DriveUIWrapper.vue';

export default defineComponent({
  props: {
    created: { type: String, required: true },
    updated: { type: String, required: true },
  },
  components: {
    DriveUiWrapper,
  },
  setup() {
    return {
      HIDE_BORDER,
    };
  },
});
